exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".title .title-nav .active a {\n  background: #022A78;\n  border-radius: 13px;\n  color: #fff !important;\n  padding: 3px 14px;\n}\n", "", {"version":3,"sources":["D:/lc_code/lc-pc/src/styles/D:/lc_code/lc-pc/src/styles/index.less"],"names":[],"mappings":"AACA;EAIQ,oBAAA;EACA,oBAAA;EACA,uBAAA;EACA,kBAAA;CAHP","file":"index.less","sourcesContent":["// 导航栏的选中样式\n.title {\n  .title-nav {\n    .active {\n      a {\n        background: #022A78;\n        border-radius: 13px;\n        color: #fff !important;\n        padding: 3px 14px;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--7-1!./node_modules/postcss-loader/lib??ref--7-2!./node_modules/less-loader/dist/cjs.js??ref--7-3!./src/styles/index.less
// module id = qIoP
// module chunks = 90